import { render, staticRenderFns } from "./ImportConfigDialog.vue?vue&type=template&id=37f08913"
import script from "./ImportConfigDialog.vue?vue&type=script&lang=js"
export * from "./ImportConfigDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports